import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';

import Select from 'components/Select';
import IconButton from 'components/IconButton';
import arrowDownIcon from 'assets/icons/arrow-down.svg';
import arrowRightIcon from 'assets/icons/arrow-right.svg';

import './styles.css';

interface SelectFilterProps {
  label: string;
  value: Array<string>;
  data: Array<{label: string; value: string}>;
  onChange: (value: Array<string>) => void;
  multi?: boolean;
  disabled?: boolean;
  classNameForTesting?: string;
}

class SelectFilter extends React.Component<SelectFilterProps> {
  state = {
    sectionOpened: false
  };

  toggleSection = () => {
    this.setState({sectionOpened: !this.state.sectionOpened});
  };

  onChange = options => {
    if (_.isUndefined(this.props.multi) || this.props.multi === true) {
      this.props.onChange(options.map(option => option.value));
    } else {
      this.props.onChange(_.get(options, 'value'));
    }
  };

  render() {
    const {multi = true} = this.props;

    return (
      <div
        className={classNames(
          'FilterSection SelectFilter',
          {
            'FilterSection--opened': this.state.sectionOpened
          },
          this.props.classNameForTesting
        )}>
        <div className="FilterSection__header colab-centered-v colab-bold">
          <IconButton
            src={arrowRightIcon}
            srcActive={arrowDownIcon}
            alt="Toggle section"
            onClick={this.toggleSection}
            active={this.state.sectionOpened}
          />
          <div>{this.props.label}</div>
        </div>

        <div className="FilterSection__content ">
          <Select
            multi={multi}
            searchable={true}
            value={this.props.value}
            options={this.props.data}
            onChange={this.onChange}
            disabled={this.props.disabled}
          />
        </div>
      </div>
    );
  }
}

export default SelectFilter;
